import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-build',
	templateUrl:'./BuildPipelinePage.html',
	styles: [],
	styleUrls:['./BuildPipelinePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BuildPipelinePage
{
	mdContent_21 = `At build time, the Angular Maven Plugin scans your classpath for \`@NgApp\`-annotated classes. It invokes the TypeScript Compiler which walks every \`@NgComponent\`, \`@NgDirective\`, \`@NgDataService\`, and \`@NgRoutable\` class. For each, it generates a \`.ts\` file, registers it in the Angular module, and adds its route to the router config. The result is a complete Angular 21 project that the Angular CLI builds into a production \`dist/\` directory.`;
	mdContent_22 = `\`\`\`mermaid
graph TD
  MVN["mvn install"]
  COMPILE["compile: javac compiles Java sources"]
  PROCESS["process-classes: Angular Maven Plugin"]
  DISCOVER["Discovers @NgApp classes on classpath"]
  TSCOMPILE["TypeScriptCompiler generates .ts files"]
  MODPROC["AngularModuleProcessor builds module tree"]
  COMPPROC["ComponentProcessor emits component .ts"]
  DEPMGR["DependencyManager writes package.json"]
  APPSETUP["AngularAppSetup generates angular.json"]
  NGBUILD["npm install + ng build --configuration production"]
  PACKAGE["package: dist/ bundled into the JAR"]

  MVN --> COMPILE --> PROCESS
  PROCESS --> DISCOVER
  PROCESS --> TSCOMPILE
  PROCESS --> MODPROC
  PROCESS --> COMPPROC
  PROCESS --> DEPMGR
  PROCESS --> APPSETUP
  DEPMGR --> NGBUILD
  APPSETUP --> NGBUILD
  NGBUILD --> PACKAGE

\`\`\``;
}
